var map = {
	"./en/AccountPayment.json": 1630,
	"./en/AppJSMessage.json": 1631,
	"./en/ContractManagement.json": 1632,
	"./en/ReportTool.json": 1633,
	"./en/ReportUsermanual.json": 1634,
	"./en/Settlements.json": 1635,
	"./en/StockTransfer.json": 1636,
	"./en/SystemMaintenanceApplicationSupport.json": 1637,
	"./en/SystemMaintenanceMasterManagement.json": 1638,
	"./en/SystemMaintenanceSpecialFunctions.json": 1639,
	"./en/WarehouseReceipts.json": 1640,
	"./en/translate.json": 1641,
	"./hi/AppJSMessage.json": 1642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1629;